import React, { useState, useEffect } from "react";
import Navigation from "../../../App/Navigation";
import { ROUTES } from "../../../../consts";
import GameCard from "../../../GameCard";
import GameInfomation from "../../../GameInfomation";
import CustomizableVariantBlock from "../../../common/ProductSectionAndDate/CustomizableVariantBlock";
import { useTrackContext } from "../../../../hooks/useTrackContext";
import { kitchenPanic, cyberClash, deathSquad } from "../../../../assets/images";
import { IGVariant, TGameCustomization, TGameOptions } from "../../../../types";
import { Link } from "react-router-dom";
import NewsletterPopup from "../../../NewsletterPopup";
import ProgressBar from "../../../ProgressiveBar";
// import { virtualRealityAccordion } from "../../../../consts/accordionInfo";
import MiniCart from "../../../Cart/MiniCart";

const VRCustomizeGame: React.FC = () => {
  const { vrSelection, productRenderedLocation } = useTrackContext();

  const {
    variantsAndDate: { selectedVariants },
    joinedVariants,
  } = vrSelection;

  const handleSpaceBeforeAMOrPM = (timeString: string) => {
    const regex = /(AM|PM)$/i;
    return timeString.replace(regex, " $1").toUpperCase();
  };

  const [isCyberClashSelected, setIsCyberClashSelected] = useState<boolean>(false);
  const [isKitchenPanicSelected, setIsKitchenPanicSelected] = useState<boolean>(false);
  const [isDeathSquadSelected, setIsDeathSquadSelected] = useState<boolean>(false);

  useEffect(() => {
    // Update your selected game states based on changes in gameCustomization
    const isCyberClashSelected = joinedVariants.some((vGame: IGVariant | TGameCustomization) => {
      if ("selectedGame" in vGame && vGame.selectedGame === "CyberClash") {
        return true;
      }

      if ("title" in vGame && vGame.title.includes("CyberClash")) {
        return true;
      }

      return false;
    });

    const isKitchenPanicSelected = joinedVariants.some((vGame: IGVariant | TGameCustomization) => {
      if ("selectedGame" in vGame && vGame.selectedGame === "Kitchen Panic") {
        return true;
      }

      if ("title" in vGame && vGame.title.includes("Kitchen Panic")) {
        return true;
      }

      return false;
    });

    const isDeathSquadSelected = joinedVariants.some((vGame: IGVariant | TGameCustomization) => {
      if ("selectedGame" in vGame && vGame.selectedGame === "Zombies") {
        return true;
      }

      if ("title" in vGame && vGame.title.includes("Zombies")) {
        return true;
      }

      return false;
    });

    // Update state variables
    setIsCyberClashSelected(isCyberClashSelected);
    setIsKitchenPanicSelected(isKitchenPanicSelected);
    setIsDeathSquadSelected(isDeathSquadSelected);
  }, [joinedVariants]);

  return (
    <>
      <ProgressBar maxValue={100} currentValue={60} />
      {productRenderedLocation === "external" && <MiniCart />}
      <div className="tw-block lg:tw-hidden">
        <span className="tw-block tw-text-[18px] lg:tw-text-[24px] tw-text-[#9D62FE] tw-font-[700] tw-mt-[30px] tw-text-center">Virtual Reality</span>
        <div className="tw-text-white tw-text-center tw-text-[24px] tw-font-extrabold">Customize your experience</div>
      </div>
      <div className="tw-hidden lg:tw-block">
        <Navigation
          previous={{
            active: true,
            to: "/" + ROUTES.VIRTUAL_REALITY.DATE_TIME,
          }}
          next={{
            active: true,
            to: "/" + ROUTES.VIRTUAL_REALITY.BOOKING_SUMMARY,
          }}
          title={"Customize your experience"}
          subtitle={"Virtual Reality"}
        />
      </div>

      <div className="container tw-mx-auto">
        <div className="tw-text-white tw-text-center tw-text-xl tw-font-bold">Your customizable game</div>
        <div className="tw-grid tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-[20px] tw-mt-[20px]">
          {selectedVariants.length &&
            // eslint-disable-next-line array-callback-return
            selectedVariants.map((variant) => {
              const { selectedOptions } = variant.variantsSelectedObject;
              const gameTimeOption = selectedOptions.find((option) => option.name.includes("Game Time"))?.value;
              const gameOption = selectedOptions.find((option) => option.name.includes("Game Option"))?.value;

              return (
                <CustomizableVariantBlock
                  key={variant.variantsSelectedObject.id}
                  variant={variant.variantsSelectedObject}
                  gameName={gameOption as TGameOptions}
                  gameTime={handleSpaceBeforeAMOrPM(gameTimeOption as string)}
                  price={Number(variant.variantsSelectedObject.priceV2.amount)}
                />
              );
            })}
        </div>

        <div className="tw-text-white tw-text-center tw-text-xl tw-font-bold tw-mb-[15px] tw-mt-[40px]">Choose your game</div>
        <div className="tw-grid tw-grid-cols-1 tw-gap-[20px] md:tw-grid-cols-3">
          <div className="tw-mx-auto lg:tw-mr-auto lg:tw-ml-[0]">
            <GameCard title="Kitchen Panic" imgSource={kitchenPanic.toString()} />
          </div>
          <div className="tw-mx-auto lg:tw-mx-auto">
            <GameCard title="Zombies" imgSource={cyberClash.toString()} />
          </div>
          <div className="tw-mx-auto lg:tw-ml-auto lg:tw-mr-[0]">
            <GameCard title="CyberClash" imgSource={deathSquad.toString()} />
          </div>
        </div>
        <div className="tw-text-white tw-text-center tw-text-xl tw-font-bold tw-mb-[10px] tw-mt-[30px]">Game Information</div>
        {isCyberClashSelected && (
          <GameInfomation
            title="CyberClash"
            children={`
          Earn the bragging rights against your mates in these Player vs. Player games. Choose* between Free-For-All, Team Deathmatch, Archery, King Of The Hill, or Battle Royale. Played in a virtual 50m x 50m arena, positioning is key to make sure you come out on top of the leaderboard.
          <br />
          <br />
          * majority rules process at the venue.
          `}
          />
        )}
        {isKitchenPanicSelected && (
          <GameInfomation
            title="Kitchen Panic"
            children={`
          "Ever wanted to increase your culinary skills? Keep calm under pressure and quickly produce the finest dishes Paris has to offer before the customers run out of patience. Chop, cook, and even throw ingredients at your teammates to get the meals served before the timer runs out!"
          `}
          />
        )}
        {isDeathSquadSelected && (
          <GameInfomation
            title="Zombies"
            children={`Team up and survive against the undead horde as they swarm your base. Earn money as you kill zombies to unlock new areas and buy powerful weapons. Can you hold on until the extraction team arrives?
            <br />
            <br />
            On Special Request: Survival Mode - How many waves can you last? Watch out! If you all die you'll be sent back to round 1. Can you beat the record? Conditions Apply (see T&Cs).`}
          />
        )}
      </div>
      <div className="tw-container tw-mx-auto tw-mt-[60px]">
        <div className="tw-flex tw-justify-center">
          <Link to={"/" + ROUTES.VIRTUAL_REALITY.BOOKING_SUMMARY}>
            <span
              className={`tw-py-[16px] tw-px-[40px] tw-font-bold tw-text-[18px] tw-rounded-[100px] tw-text-white tw-bg-[linear-gradient(150deg,#9D62FE_0%,#A852FF_28.13%,#AD44FF_52.08%,#7886FF_100%)]`}
            >
              Next
            </span>
          </Link>
        </div>
      </div>

      <div className="tw-w-full lg:tw-h-[126px] tw-p-[30px] tw-mt-[40px] lg:tw-mt-0">
        <div className="tw-flex tw-justify-center tw-items-center">
          <div className="tw-block lg:tw-hidden">
            <Navigation
              previous={{
                active: true,
                to: "/" + ROUTES.VIRTUAL_REALITY.DATE_TIME,
              }}
              next={{
                active: true,
                to: "/" + ROUTES.VIRTUAL_REALITY.BOOKING_SUMMARY,
              }}
              title={"Customize your experience"}
              subtitle={"Virtual Reality"}
            />
          </div>
          <div
            className={`${
              productRenderedLocation === "external" ? "tw-container tw-mx-auto" : "container mx-auto"
            } tw-relative tw-flex tw-justify-end tw-items-center tw-gap-[15px] lg:tw-block`}
          >
            {" "}
            <NewsletterPopup />
          </div>
        </div>
      </div>
    </>
  );
};

export default VRCustomizeGame;
